import axios from "axios";

import { PaymentSessionToken } from "redmond";
import {
  purchaseApi,
  PaymentOpaqueValue,
  AncillaryOpaqueValue,
} from "@b2bportal/purchase-api";
import { ProductFunnelHeaderName, ProductFunnelHeader } from "./productFunnel";

const schedulePayment = (
  token: PaymentSessionToken,
  payments: Array<PaymentOpaqueValue>,
  ancillaries: AncillaryOpaqueValue[] = [],
  channel: "TravelApp" | "Mobile" | "Web",
  corporateOutOfPolicyReason?: string,
  corporateTripDescription?: string,
  productFunnel: ProductFunnelHeader = ProductFunnelHeader.Hotels
): Promise<string> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV0PurchaseFulfillSchedulePost(
        {
          quoteToken: {
            value: token.value,
          },
          payments,
          ancillaries,
          corporateOutOfPolicyReason,
          corporateTripDescription,
          channel,
        },
        { headers: { [ProductFunnelHeaderName]: productFunnel } }
      );

      res.then((body) => resolve(body.data.value)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });

export default schedulePayment;
